module.exports = __webpack_public_path__ + "img/webm.1212fc16.svg";